import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { Stack } from "@mui/material";
import { ReactComponent as Logo } from "../../images/logo.svg";
import Logout from "@mui/icons-material/Logout";
import BasicSearch from "../Search/BasicSearch";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";

export type RSAdminNavbarProps = {
  className?: string;
};

const RSAdminNavBar = (/* { className }: RSAdminNavbarProps */) => {
  const navigate = useNavigate();
  
  const { logout } = useAuth();

  const dashboard = () => {
    navigate("/dashboardrsadmin");
  };
  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <div className="NavBar">
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static">
          <Toolbar
            sx={{
              maxHeight: "200px",
              marginLeft: "-60px",
              marginBottom: "10px",
              marginTop: "-15px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Logo
              height={100}
              onClick={dashboard}
            />
            <BasicSearch rsAdmin />
            <Stack
              direction={"row"}
              spacing={2}
              sx={{
                height: "100%",
                alignItems: "center",
                marginTop: "25px",
              }}
            >
              <Logout
                sx={{ cursor: "pointer" }}
                onClick={handleLogout}
              />
            </Stack>
          </Toolbar>
        </AppBar>
      </Box>
    </div>
  );
};
export default RSAdminNavBar;
